// Canonical lead-dropdown options — mirrors backend `LEAD_*` constants
// in server.py. Centralised here so NewLeadDialog, filter toolbar, and
// LeadRow card all consume the same `{key,label}` shapes.
//
// Source of truth: customer-uploaded `Lead Page.xlsx`. Typos in the
// source spreadsheet have been corrected ("Exisitng" → "Existing",
// "LinkedIn Compaign" → "LinkedIn Campaign", "Expanasion" → "Expansion",
// "Techncial" → "Technical", trailing spaces trimmed).

// 30.docx: exact Industry Sector names — these ARE the Marketing Contact
// category names (single source of truth, spelling/spacing/& must match).
export const LEAD_INDUSTRIES = [
  "Other / Unclassified",
  "Steel & Metals",
  "Power & Utilities",
  "Engineering & Manufacturing",
  "Cement & Building Materials",
  "IT & Software",
  "Oil & Gas",
  "Automotive",
  "Chemicals",
  "Pharmaceuticals & Biotechnology",
  "Food & Beverage",
  "Government & Public Sector",
  "Construction & Infrastructure",
  "FMCG & Consumer Goods",
  "Logistics & Transportation",
  "Telecommunications",
  "Textiles & Apparel",
  "Education",
  "Agriculture",
  "Healthcare & Hospitals",
  "Retail & E-commerce",
  "Banking & Financial Services",
].map((name) => ({ key: name, label: name }));

export const LEAD_SOURCES = [
  { key: "lead_growth_plan",         label: "Lead Growth Plan" },
  { key: "crm_contacts",             label: "CRM Contacts" },
  { key: "existing_user",            label: "Existing User" },
  { key: "existing_user_referral",   label: "Existing User Referral" },
  { key: "team_referral",            label: "Team Referral" },
  { key: "repeat_opportunities",     label: "Repeat Opportunities" },
  { key: "onsite_training",          label: "On-Site Training" },
  { key: "product_support",          label: "Product Support" },
  { key: "certification_course",     label: "Certification Course" },
  { key: "digital_marketing",        label: "Digital Marketing" },
  { key: "linkedin_campaign",        label: "LinkedIn Campaign" },
  { key: "renviro_website",          label: "Renviro Website" },
  { key: "inbound_enquiry",          label: "Inbound Enquiry" },
  { key: "customer_visit",           label: "Customer Visit" },
  { key: "webinars",                 label: "Webinars" },
  { key: "exhibition_conference",    label: "Exhibition / Conference" },
  { key: "gem_indiamart",            label: "GeM / IndiaMART" },
  { key: "cross_selling",            label: "Cross-Selling" },
  { key: "expansion_project",        label: "Expansion Project" },
  { key: "multi_location_industries", label: "Multi-Location Industries" },
  { key: "other_sources",            label: "Other Sources" },
];

export const LEAD_APPLICATIONS = [
  { key: "bearing",                  label: "Bearing" },
  { key: "electrical",               label: "Electrical" },
  { key: "rotating_machines",        label: "Rotating Machines" },
  { key: "compressed_air_audit",     label: "Compressed Air Audit" },
  { key: "steamtrap_inspection",     label: "Steamtrap Inspection" },
  { key: "valve_inspection",         label: "Valve Inspection" },
  { key: "thermal_inspection",       label: "Thermal Inspection" },
  { key: "safety",                   label: "Safety" },
  { key: "general",                  label: "General" },
];

export const LEAD_OUTREACH = [
  { key: "introductory_emails",      label: "Introductory Emails" },
  { key: "linkedin_connection",      label: "LinkedIn Connection" },
  { key: "cold_calls",               label: "Cold Calls" },
  { key: "case_studies",             label: "Case Studies" },
  { key: "industry_benchmarking",    label: "Industry Benchmarking" },
  { key: "demonstration_example",    label: "Demonstration Example" },
];

// "Potential" = which Renviro offering this lead is potentially interested in.
export const LEAD_POTENTIALS = [
  { key: "ultraprobes",              label: "Ultraprobes" },
  { key: "acoustic_imager",          label: "Acoustic Imager" },
  { key: "thermal_imager",           label: "Thermal Imager" },
  { key: "technical_services",       label: "Technical Services" },
  { key: "training",                 label: "Training" },
  { key: "tev_hfct",                 label: "TEV & HFCT" },
  { key: "lv_inspection",            label: "LV Inspection" },
  { key: "online_monitoring",        label: "On-Line Monitoring" },
];

export const LEAD_FOLLOWUP_STAGES = [
  { key: "technical_discussion",     label: "Technical Discussion" },
  { key: "lead_qualification",       label: "Lead Qualification" },
];

// Quick lookup `key → label` for badge rendering on lead cards.
export const labelOf = (list, key) => (list.find((o) => o.key === key) || {}).label || key || "";

export const INDUSTRY_LABEL    = Object.fromEntries(LEAD_INDUSTRIES.map((o) => [o.key, o.label]));
export const SOURCE_LABEL      = Object.fromEntries(LEAD_SOURCES.map((o) => [o.key, o.label]));
export const APPLICATION_LABEL = Object.fromEntries(LEAD_APPLICATIONS.map((o) => [o.key, o.label]));
export const OUTREACH_LABEL    = Object.fromEntries(LEAD_OUTREACH.map((o) => [o.key, o.label]));
export const POTENTIAL_LABEL   = Object.fromEntries(LEAD_POTENTIALS.map((o) => [o.key, o.label]));
export const FOLLOWUP_LABEL    = Object.fromEntries(LEAD_FOLLOWUP_STAGES.map((o) => [o.key, o.label]));
